import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { blogPost } from '../../../Models/Session';
import { AuthService } from '../../../Services/auth.service';
import { BaseApiService } from '../../../Services/base-api.service';
import { ImageUploadService } from '../../../Services/image-upload.service';
import { RichTextEditorService } from '../../../Services/rich-text-editor.service';


@Component({
  selector: 'app-show-pages',
  templateUrl: './show-pages.component.html',
  styleUrls: ['./show-pages.component.css'],standalone:false
})
export class ShowPagesComponent implements OnInit {


  sessionDataArray: blogPost[] = [];
  selectedRecord!: blogPost;
  editorContent: string = "";
  recordForm!: FormGroup;
  selected:boolean=false;
  loading:boolean=false;
  imageUrl: string = '';

  constructor
  (
    private api:BaseApiService,
    private imageUploadService:ImageUploadService,
    private auth:AuthService,
    private editorService: RichTextEditorService,
    private http:HttpClient,private messageService:MessageService,private fb: FormBuilder)
   {


      this.recordForm = this.fb.group({
        id: new FormControl(''),
        title: new FormControl('', [Validators.required]),
        description: new FormControl('', [Validators.required]),
        metaDescription: new FormControl('', [Validators.required]),
        image:new FormControl(''),
        mainCategory:new FormControl('',[Validators.required]),
        subCategory: new FormControl('',[Validators.required])
      });

  }
  getdat(){
    this.loading=true;
    this.api.read("Page/GetAllPages").subscribe
    (
      (response)=>{
        this.sessionDataArray = response;
        this.loading=false;
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }
  ngOnInit(): void {
    
    this.getdat();

    if (this.sessionDataArray && this.sessionDataArray.length > 0) {
        this.recordForm.patchValue(this.selectedRecord);
    }

   }


   selectRecord(record: any) {
    this.selected=true;
    this.selectedRecord = record;
    this.imageUrl=this.selectedRecord.image;
    this.editorService.setEditorContent(this.selectedRecord.description);
    this.recordForm.patchValue(record);

  }

  deRecord(id:any) {
    this.loading=true;
    this.api.delete(`Page?id=${id}`).subscribe
    (
      (response)=>{
        this.loading=false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
        this.getdat();
        this.recordForm.reset();
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )

  }

  updateRecord() {
    this.loading=true;
    const updatedRecord = this.recordForm.value;
    this.api.update("Page",updatedRecord).subscribe
    (
      (response)=>{
        this.loading=false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
        this.recordForm.reset();
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )

  }



  upload(event: any): void {
    this.loading=true
    const file: File = event.target.files[0];
    if (file) {

     this.imageUploadService.uploadImage(file)
     .subscribe
     ((imageUrl: string) => {
       this.imageUrl = imageUrl;
       this.recordForm.get('image')?.setValue(imageUrl);
       this.loading=false;
     }
     ,(error)=>{
      {
        this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });

      }
     }
     );


    }
  }


 


}
